import { createSlice } from '@reduxjs/toolkit';
// import type { PayloadAction } from '@reduxjs/toolkit';

export interface SeccionEjercicioState {
    eid: string
    cid: string
    mid: string
    bid: string
    sid: string
    numero: number
    tipo: string
    enunciado: string
    alternativas: Array<AlternativaState>
    respuesta: string
    variable: string, 
    estado?: boolean
}

export interface AlternativaState {
    alternativa: string
    letra: string
    estado: boolean
}

export interface SeccionEjerciciosState {
    ejercicio: SeccionEjercicioState
    ejercicios: Array<SeccionEjercicioState>
    isLoading: boolean
}

const initialState: SeccionEjerciciosState = {
    ejercicio: {
        eid: '', 
        cid: '', 
        mid: '', 
        bid: '', 
        sid: '', 
        numero: 0, 
        tipo: '', 
        enunciado: '', 
        alternativas: [{alternativa: '', letra: '', estado: false}],
        respuesta: '',
        variable: ''
    },
    ejercicios: [], 
    isLoading: false
}

export const seccionEjercicioSlice = createSlice({
    name: 'seccion-ejercicio',
    initialState,
    reducers: {
        setSeccionEjercicio: (state, action) => {
            state.ejercicio = action.payload
        },
        setSeccionEjercicios: (state, action) => {
            state.ejercicios = action.payload
        },
        startLoadingSeccionEjercicio: (state) => {
            state.isLoading = true;
        },
        endLoadingSeccionEjercicio: (state) => {
            state.isLoading = false;
        },
    },
})

// Action creators are generated for each case reducer function
export const { 
    setSeccionEjercicio,
    setSeccionEjercicios,
    startLoadingSeccionEjercicio, 
    endLoadingSeccionEjercicio 
} = seccionEjercicioSlice.actions

